import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import 'normalize.css';
import '@/utils/rem.js';
import '@/css/common.css';
import '@/assets/font/fonts.css'; // 引入字体配置
import AnimeTitle from '@/components/AnimeTitle/index.vue';
import RoundedButton from '@/components/RoundedButton/index.vue';
import enhancedUtils from '@/utils/intersection/intersection-utils-enhanced';
import languageMixin from '@/mixins/languageMixin';
// import '@/css/save-scale-animation.css';

// Element Plus 封装
import installElementPlus from '@/plugins/element.js';

// 覆盖样式已在 plugins/element.js 中集中处理

const app = createApp(App);

// 全局挂载到 app.config.globalProperties
app.config.globalProperties.$intersection = enhancedUtils;

// 注册全局混入
app.mixin(languageMixin);

// 注册全局组件
app.component('AnimeTitle', AnimeTitle);
app.component('RoundedButton', RoundedButton);

// 安装 Element Plus（组件注册 + 服务挂载 + 样式覆盖）
installElementPlus(app);

app.use(store).use(router).use(i18n).mount('#app');
